import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class FileLoader extends Loader {}

export const fileLoader = new FileLoader({
  service: SERVICES.file
})
